import React, { FC, useContext } from 'react'
import { Text as RNText } from 'react-native'
import { useField } from 'formik'

import { Element } from '../Element'

import { FormFieldContext } from './FormField'

interface FormFieldErrorProps {
  size?: number
  variant?: string
  message?: string
}

export const FormFieldError = ({
  size = 5,
  variant,
  message,
}: FormFieldErrorProps) => {
  const formFieldContext = useContext(FormFieldContext)
  const [field, meta] = useField(formFieldContext)

  message = message || meta.error

  if (!meta.touched) {
    return null
  }

  if (!message) {
    return null
  }

  return (
    <Element
      as={RNText}
      tokens={{ fontSize: size, lineHeight: size }}
      component='FormFieldError'
      variant={variant}
    >
      {message}
    </Element>
  )
}
